import {
  ConfirmModalContextProvider,
  ThemeContextProvider,
  ViewportContextProvider,
  GlobalStyle,
} from '@mgmresorts/wcl-core';
import React from 'react';

import { useLogrocketTracking } from './hooks/useLogrocketTracking';
import { AnalyticsServiceProvider } from './utils/analytics/analytics';
import { AuthContextProvider } from './utils/auth/AuthProvider';
import { OfflineContextProvider } from './utils/offlineContext';
import { PersistentParametersContextProvider } from './utils/persistParameterContext';
import { UserAccountContextProvider } from './utils/userAccountContext';
import {
  BackdropContextProvider,
  BodyScrollLockContextProvider,
  EscKeyListenContextProvider,
} from './utils/wcl-core/context';

export const ContextWrappers = (props: { children: React.ReactNode | React.ReactNodeArray }) => {
  useLogrocketTracking();

  return (
    <ThemeContextProvider>
      <ViewportContextProvider>
        <BackdropContextProvider>
          <BodyScrollLockContextProvider>
            <EscKeyListenContextProvider>
              <ConfirmModalContextProvider>
                <AnalyticsServiceProvider>
                  <PersistentParametersContextProvider>
                    <OfflineContextProvider>
                      <AuthContextProvider>
                        <UserAccountContextProvider>
                          <GlobalStyle />
                          {props.children}
                        </UserAccountContextProvider>
                      </AuthContextProvider>
                    </OfflineContextProvider>
                  </PersistentParametersContextProvider>
                </AnalyticsServiceProvider>
              </ConfirmModalContextProvider>
            </EscKeyListenContextProvider>
          </BodyScrollLockContextProvider>
        </BackdropContextProvider>
      </ViewportContextProvider>
    </ThemeContextProvider>
  );
};
